import { render, staticRenderFns } from "./Savebutton.vue?vue&type=template&id=683b4a0e&"
import script from "./Savebutton.vue?vue&type=script&lang=js&"
export * from "./Savebutton.vue?vue&type=script&lang=js&"
import style0 from "./Savebutton.vue?vue&type=style&index=0&id=683b4a0e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports